import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import { helpAnswers } from '../../data/helpAnswers';
export function HelpAnswers({
  screen,
  className = ''
}: {
  screen: string;
  className?: string;
}) {
  const {
    t,
    lang
  } = useFunnel();
  const items = helpAnswers[screen];
  if (!items?.length) return null;
  return <section aria-label={t('helpQuick')} className={className} data-id="element-454" data-mp="1nilgzbkajz8i">
      <h2 className="mb-2 flex items-center gap-2 text-sm font-semibold text-ink-600" data-id="element-455" data-mp="1nk6e98xzpwa2">
        <div className="h-4 w-4" aria-hidden="true" data-id="element-456" data-mp="1sheuv53hps97" />
        {t('helpQuick')}
      </h2>
      <div className="divide-y divide-ink-200 border-y border-ink-200" data-id="element-457" data-mp="1xeojiij21zvz">
        {items.map(it => <details key={it.q.en} className="group" data-id="element-458" data-mp="22g42m51o9wbq">
            <summary className="flex min-h-[48px] cursor-pointer list-none items-center justify-between gap-3 py-2 text-[15px] font-semibold text-ink [&::-webkit-details-marker]:hidden" data-id="element-459" data-mp="38voks3ndrp25">
              {it.q[lang]}
              <ChevronDownIcon className="h-4 w-4 shrink-0 text-ink-500 transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-460" data-mp="1x29xucb0n49t" />
            </summary>
            <p className="pb-3 text-[15px] leading-relaxed text-ink-600" data-id="element-461" data-mp="1o11zju8i23fq">{it.a[lang]}</p>
          </details>)}
      </div>
    </section>;
}